import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useQueryClient } from 'react-query';
import { useGetContactList } from 'routes/screens/lists/hooks';
import { McrContactType } from 'shared/types';

type ContactListNameType = {
  id: string;
  contactId: string;
  showLoader?: boolean;
  showDeleted?: boolean;
};

const ContactListName = (props: ContactListNameType) => {
  const { id, contactId, showLoader = true, showDeleted = false } = props;
  const queryClient = useQueryClient();
  const {
    data: contactList,
    isLoading,
    isError,
  } = useGetContactList({
    contactListId: id,
    showDeleted,
  });

  React.useEffect(() => {
    if (!isError) return;
    queryClient.setQueryData<McrContactType>(
      ['contact', contactId],
      (contact) => {
        const newContact: McrContactType = {
          ...contact,
          fields: {
            ...(contact?.fields || {}),
            list_ids: contact?.fields?.list_ids.filter(
              (listId) => listId !== id,
            ),
          },
        };
        return newContact;
      },
    );
  }, [isError]);

  if (isError) return <>{id}</>;

  return isLoading ? (
    <>{showLoader ? <Skeleton height={18} width={50} /> : id}</>
  ) : (
    <>{contactList?.label || id}</>
  );
};

export default ContactListName;
